// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';

import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import Badge from '@cloudscape-design/components/badge';

const navHeader = { text: 'Seguridad', href: '#/' };
export const navItems: SideNavigationProps['items'] = [
  {
    type: 'section',
    text: 'Bloqueos',
    items: [
      { type: 'link', text: 'Accesos', href: '#/distributions3' },
      { type: 'link', text: 'Unidades', href: '#/cache' },
      { type: 'link', text: 'Usuarios', href: '#/monitoring' },
    ],
  },
  {
    type: 'section',
    text: 'Asignaciones',
    items: [
      { type: 'link', text: 'Accesos', href: '#/howto' },
      { type: 'link', text: 'Unidades', href: '#/origin1' },
      { type: 'link', text: 'Políticas', href: '#/origin2' },
    ],
  },
  {
    type: 'section',
    text: 'Restricciones',
    items: [
      { type: 'link', text: 'Asignaciones', href: '#/howto3' },
      { type: 'link', text: 'Políticas', href: '#/origin3', 
        info: <Badge color="red">23</Badge> },
    ],
  },
  {
    type: 'section',
    text: 'Geolocalizaciones',
    items: [
      { type: 'link', text: 'Accesos', href: '#/howto2' },
      { type: 'link', text: 'Unidades', href: '#/origin4' },
    ],
  },
];

const defaultOnFollowHandler: SideNavigationProps['onFollow'] = event => {
  // keep the locked href for our demo pages
  event.preventDefault();
};

interface NavigationProps {
  activeHref?: string;
  header?: SideNavigationProps['header'];
  items?: SideNavigationProps['items'];
  onFollowHandler?: SideNavigationProps['onFollow'];
}

export function Navigation({
  activeHref,
  header = navHeader,
  items = navItems,
  onFollowHandler = defaultOnFollowHandler,
}: NavigationProps) {
  return <SideNavigation items={items} header={header} activeHref={activeHref} onFollow={onFollowHandler} />;
}
